(() => {
  const api = 'https://api.zapiet.com/v1.0/pickup/locations';
  const fallback = 'Beschikbare ophaaldagen en tijden kies je in de winkelwagen.';
  const monthLabel = new Intl.DateTimeFormat('nl-NL', {
    month: 'long', year: 'numeric', timeZone: 'UTC',
  });

  function normalise(value) {
    return window.BbZapiet.normalise(value);
  }

  async function postJson(url, body) {
    return window.BbZapiet.post(url, body);
  }

  function productsFor(section) {
    return ['with', 'without'].flatMap((kind) => {
      const productId = Number(section.dataset[`zapiet${kind[0].toUpperCase()}${kind.slice(1)}Product`]);
      const variantId = Number(section.dataset[`zapiet${kind[0].toUpperCase()}${kind.slice(1)}Variant`]);
      return productId && variantId ? [{ product_id: productId, variant_id: variantId, quantity: 1 }] : [];
    });
  }

  function showAddress(section, location) {
    const card = section.querySelector('[data-zapiet-address]');
    const address = [location?.address_line_1, location?.address_line_2, location?.postal_code, location?.city]
      .filter(Boolean)
      .join(', ');
    if (address) {
      card.querySelector('[data-zapiet-address-text]').textContent = address;
      card.querySelector('[data-zapiet-route]').href = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
      card.querySelector('[data-zapiet-route-wrap]').hidden = false;
    } else if (card.classList.contains('is-loading')) {
      card.querySelector('[data-zapiet-address-text]').textContent = 'Adresgegevens zijn nu niet beschikbaar.';
    }
    card.hidden = false;
    card.classList.remove('is-loading');
    card.classList.add('is-ready');
    card.setAttribute('aria-busy', 'false');
  }

  function showScheduleStatus(output, message) {
    const status = output.querySelector('[data-zapiet-status]');
    status.textContent = message;
    status.hidden = false;
    output.querySelector('[data-zapiet-month]').hidden = true;
    output.querySelector('[data-zapiet-schedule]').hidden = true;
    output.querySelector('[data-zapiet-note]').hidden = true;
  }

  function showSchedule(output, schedule) {
    const rows = schedule.map(({ date, slots }) => ({ date, formatted: window.BbZapiet.formatPickupDay(date, slots) }))
      .filter(({ formatted }) => formatted);
    if (!rows.length) {
      showScheduleStatus(output, fallback);
      return;
    }
    const list = output.querySelector('[data-zapiet-schedule]');
    list.replaceChildren();
    for (const { formatted } of rows) {
      const item = document.createElement('li');
      const day = document.createElement('span');
      const time = document.createElement('span');
      day.textContent = formatted.day;
      time.textContent = formatted.time;
      item.append(day, time);
      list.append(item);
    }
    const month = output.querySelector('[data-zapiet-month]');
    month.textContent = [...new Set(rows.map(({ date }) => monthLabel.format(new Date(`${date}T12:00:00Z`))))].join(' · ');
    month.hidden = false;
    list.hidden = false;
    const note = output.querySelector('[data-zapiet-note]');
    note.textContent = schedule.length === 6
      ? 'Het definitieve moment en eventuele extra dagen kies je in de winkelwagen.'
      : 'Het definitieve moment kies je in de winkelwagen.';
    note.hidden = false;
    const status = output.querySelector('[data-zapiet-status]');
    status.textContent = '';
    status.hidden = true;
  }

  async function update(section) {
    const shop = encodeURIComponent(section.dataset.zapietShop || '');
    const products = productsFor(section);
    if (!shop || !products.length) return;
    const datesOutput = section.querySelector('[data-zapiet-dates]');
    const checking = 'Ophaalmomenten controleren…';
    showScheduleStatus(datesOutput, checking);
    datesOutput.classList.remove('is-ready');
    datesOutput.classList.add('is-loading');
    datesOutput.setAttribute('aria-busy', 'true');
    let selectedLocation = null;
    try {
      const responses = await Promise.all(products.map((product) =>
        postJson(`${api}?shop=${shop}&limit=200`, { shoppingCart: [product] })
      ));
      const candidates = (responses[0].locations || []).filter((location) =>
        responses.every((response) => (response.locations || []).some((other) => other.id === location.id))
      );
      const configuredId = section.dataset.zapietLocationId;
      const collectionName = normalise(section.dataset.zapietCollection);
      const locationCity = candidates.length === 1 ? normalise(candidates[0].city) : '';
      const cityMatches = locationCity && (
        collectionName === locationCity || collectionName.startsWith(`${locationCity} `)
      );
      const location = configuredId
        ? candidates.find((candidate) => String(candidate.id) === configuredId)
        : products.length === 2 && candidates.length === 1 && cityMatches
          ? candidates[0]
          : products.length === 1
            ? window.BbZapiet.resolve(candidates, '', section.dataset.zapietCollection, false)
            : null;
      if (!location) return;
      selectedLocation = location;

      section.querySelectorAll('.bb-pickup__product-button').forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('bb_pickup_location', String(location.id));
        link.href = url.toString();
      });
      const schedule = await window.BbZapiet.pickupSchedule(decodeURIComponent(shop), location.id, products, 6);
      showAddress(section, location);
      showSchedule(datesOutput, schedule);
    } catch (_error) {
      if (selectedLocation) showAddress(section, selectedLocation);
      showScheduleStatus(datesOutput, fallback);
    } finally {
      const addressCard = section.querySelector('[data-zapiet-address]');
      if (addressCard?.classList.contains('is-loading')) showAddress(section, null);
      if (datesOutput.querySelector('[data-zapiet-status]').textContent === checking) showScheduleStatus(datesOutput, fallback);
      datesOutput.classList.remove('is-loading');
      datesOutput.classList.add('is-ready');
      datesOutput.setAttribute('aria-busy', 'false');
    }
  }

  document.querySelectorAll('.bb-pickup[data-zapiet-shop]').forEach(update);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.bb-pickup[data-zapiet-shop]').forEach(update);
  });
})();
